import { memo } from "react";
import { ProductMediaProvider } from "./ProductMediaContext";
import ProductBase from "./Base";
import ProductCustom1 from "./Custom1";
import useProductViewModel from "./useProductViewModel";
import { useThemeLayout } from "contexts/store";

const Product = () => {
    const viewModel = useProductViewModel();
    const themeLayout = String(useThemeLayout() || "base").toLowerCase();

    if (viewModel.loading) {
        return <div>..loading</div>;
    }

    const Layout = themeLayout === "custom1" ? ProductCustom1 : ProductBase;

    return (
        <ProductMediaProvider images={viewModel.images || []}>
            <Layout viewModel={viewModel} />
        </ProductMediaProvider>
    );
};

export default memo(Product)